<header class="newheader">
    <div class="top-bar">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <a [routerLink]="['/']" class="logo">
                        <img src="assets/img/shared/logo.png" alt="CarData">
                    </a>
                    <div class="top-text">2012 yılından beri Kurumsal ve Profesyonel Otomotiv Datası Çözümleri<a
                            href="https://partner.turkcell.com.tr/Partners/CARDATA" target="_blank"
                            class="trkcll-partner">
                            <i class="sprite icon-turkcellLogo"></i>
                        </a>
                    </div>
                    <div class="top-menu">
                        <ul class="clearfix" style="display: hide">
                            <li>
                                <a href="package-info.htm" class="btn btn-primary btn-xs">satın al</a>
                            </li>
                            <li>
                                <a href="https://www.cardataplus.com" target="_blank" class="btn btn-default">
                                    <i class="sprite icon-avatar"></i><span>üye girişi</span>
                                </a>
                            </li>
                            <li>
                                <a href="https://api.whatsapp.com/send?phone=905384913362&text=CarData®"
                                    class="btn btn-default" target="_blank">
                                    <i class="fa fa-whatsapp"></i><span>7/24 Whatsapp<br />0538 491 33 62</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div class="member-mobile-menu">
                        <a href="javascript:void(0)" id="mobilMenu" class="mobile-menu clearfix">
                            <span>MENÜ</span>
                            <i class="fa fa-bars"></i>
                        </a>
                        <ul class="mobile-row-menu">
                            <li>
                                <a [routerLink]="['/']">
                                    Anasayfa
                                </a>
                            </li>
                            <li>
                                <a [routerLink]="['/products']">
                                    Ürünlerimiz
                                </a>
                            </li>
                            <li>
                                <a [routerLink]="['/bayimiz-olun']">
                                    Bayimiz Olun
                                </a>
                            </li>
                            <li>
                                <a [routerLink]="['/about-us']">
                                    Hakkımızda
                                </a>
                            </li>
                            <li>
                                <a [routerLink]="['/media']">
                                    Medya
                                </a>
                            </li>
                            <li>
                                <a [routerLink]="['/contact']">
                                    İletişim
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="menu-bar">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <ul class="main-menu">
                        <li>
                            <a [routerLink]="['/contact']">
                                İletişim
                            </a>
                        </li>
                        <li>
                            <a [routerLink]="['/media']">
                                Medya
                            </a>
                        </li>

                        <li>
                            <a [routerLink]="['/about-us']">
                                Hakkımızda
                            </a>
                        </li>
                        <li>
                            <a [routerLink]="['/bayimiz-olun']">
                                Bayimiz Olun
                                <span>Tüm Türkiye</span>
                            </a>
                        </li>
                        <li>
                            <a [routerLink]="['/products']">
                                Ürünlerimiz
                            </a>
                        </li>
                        <li>
                            <a href="/">
                                Anasayfa
                            </a>
                        </li>
                    </ul>
                    <ul class="hizli-menu">
                        <li>
                            <a [routerLink]="['/instant-cash-offer']">Bayi ve Galeriler için<br />2.El Araç Tedariği</a>
                        </li>
                        <li>
                            <a [routerLink]="['/used_car_pricing']">2.El Araç Fiyatlandırma<br />Uygulaması</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</header>
